// extracted by mini-css-extract-plugin
module.exports = {"primaryFacet":"PrimaryFacet_primaryFacet__hZaM9","primaryFacet--mobile-only":"PrimaryFacet_primaryFacet--mobile-only__adPOR"};